import type { Space } from "../../api/spaces";

export type SpacesLandingMemory = {
    joinedSpaces: Space[];
    discoverSpaces: Space[];
    search: string;
    scrollTop: number;
    loadedAt: number;
};

export type SpacesListKind = "all" | "archives";

export type SpacesDirectoryMemory = {
    spaces: Space[];
    page: number;
    hasMore: boolean;
    searchInput: string;
    searchQuery: string;
    scrollTop: number;
    loadedAt: number;
};

let landingMemory: SpacesLandingMemory | null = null;
const directoryMemory: Partial<Record<SpacesListKind, SpacesDirectoryMemory>> = {};

export function readSpacesLandingMemory() {
    return landingMemory;
}

export function rememberSpacesLandingMemory(patch: Partial<SpacesLandingMemory>) {
    landingMemory = {
        joinedSpaces: patch.joinedSpaces ?? landingMemory?.joinedSpaces ?? [],
        discoverSpaces: patch.discoverSpaces ?? landingMemory?.discoverSpaces ?? [],
        search: patch.search ?? landingMemory?.search ?? "",
        scrollTop: patch.scrollTop ?? landingMemory?.scrollTop ?? 0,
        loadedAt: Date.now(),
    };
}

export function readSpacesDirectoryMemory(kind: SpacesListKind) {
    return directoryMemory[kind] || null;
}

export function rememberSpacesDirectoryMemory(kind: SpacesListKind, patch: Partial<SpacesDirectoryMemory>) {
    const current = directoryMemory[kind];
    directoryMemory[kind] = {
        spaces: patch.spaces ?? current?.spaces ?? [],
        page: patch.page ?? current?.page ?? 1,
        hasMore: patch.hasMore ?? current?.hasMore ?? true,
        searchInput: patch.searchInput ?? current?.searchInput ?? "",
        searchQuery: patch.searchQuery ?? current?.searchQuery ?? "",
        scrollTop: patch.scrollTop ?? current?.scrollTop ?? 0,
        loadedAt: Date.now(),
    };
}

export function resetSpacesListMemory() {
    landingMemory = null;
    delete directoryMemory.all;
    delete directoryMemory.archives;
}

export function forgetSpaceFromListMemory(spaceId: string) {
    const id = String(spaceId || '');
    if (!id) return;
    if (landingMemory) {
        landingMemory = {
            ...landingMemory,
            joinedSpaces: landingMemory.joinedSpaces.filter((space) => space.id !== id),
            discoverSpaces: landingMemory.discoverSpaces.filter((space) => space.id !== id),
            loadedAt: Date.now(),
        };
    }
    (['all', 'archives'] as SpacesListKind[]).forEach((kind) => {
        const current = directoryMemory[kind];
        if (!current) return;
        directoryMemory[kind] = {
            ...current,
            spaces: current.spaces.filter((space) => space.id !== id),
            loadedAt: Date.now(),
        };
    });
}
